module.exports = __webpack_public_path__ + "static/d2c-bab1b610c964899d6d5c34d2fe0d46d3.png";